<template>
    <div class="wrap">
        <listHeader
            :title="postData.scid > 0 ? '编辑学院' : '新增学院'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="college"
                active="info"
                :scid="postData.scid"
            ></hro-tab>

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="学院名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入学院名称" v-decorator="['scname', {rules: [{ required: true, max: 64, message: '请输入学院名称' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="用户名"
                                v-bind="formItemLayout"
                            >
                                <a-input placeholder="用户名（填写后更新用户名）" v-decorator="['username', {rules: [{ required: false, max: 32, message: '请输入用户名' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import hroTab from '@/components/list/tab';

export default {
    components: {
        listHeader,
        hroTab
    },
    data() {
        return {
            scenario: 'collegeCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'sid': '',
                'scid': '',
            },
            data: {},
            config: {},
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/college/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.scid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            scname: res.data.scname,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.scid > 0) {
                            url = '/manage/college/edit';
                            values.scid = this.postData.scid;
                        } else {
                            url = '/manage/college/save';
                            values.sid = this.postData.sid;
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                if (this.postData.scid == '') {
                                    this.$router.go(-1);
                                } else {
                                    this.getData();
                                }
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
